import { OnBoardingMessage } from './on-boarding-message.model';
import { Injectable } from '@angular/core';
import { ApiUxService } from '../shared/api-ux/api-ux.service';
import { map } from 'rxjs/operators';
import { ApiUxInitService } from '../services/init/api-ux-init.service';

@Injectable({
  providedIn: 'root',
})
export class OnBoardingService extends ApiUxInitService<OnBoardingMessage[]> {
  constructor(apiUxService: ApiUxService) {
    super(apiUxService, 'on-boarding');
  }

  isOnBoardingDone() {
    return this.apiUxService
      .get<IsOnBoardingDoneResult>('on-boarding/done')
      .pipe(map(result => result.isOnBoardingDone));
  }

  finished() {
    return this.apiUxService.post<void>('on-boarding/done', {});
  }
}

class IsOnBoardingDoneResult {
  isOnBoardingDone: boolean;
}
